// @flow
import i18n from 'i18n-js';

import * as reportActions from '../../../actions/reports';

export const validate = (values: Object) => {
  const {
    date_range,
    student,
  } = values;

  const errors = {};

  if (!student) {
    errors.student = i18n.t('labels.requiredField');
  }

  if (!date_range) {
    errors.from_type = i18n.t('labels.requiredField');
  }

  return {};
};

const getDateArray = (startDate: date, stopDate: date) => {
  const dateArray = [];
  const currentDate = new Date(startDate);
  const endDate = new Date(stopDate);
  while (currentDate <= endDate) {
    dateArray.push(new Date(currentDate).toISOString().substr(0, 10));
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dateArray;
};

export const onSubmit = (values: Object, dispatch: Function, props: Object) => {
  const { date_range, selectedElement } = values;
  // const dateArray = getDateArray(date_range.startDate, date_range.endDate);
  if (values.date_range && values.date_range.startDate && values.date_range.endDate && values.selectedElement) {
    dispatch(reportActions.startFetchReport(props.report.key, selectedElement, date_range));
  }
};



// WEBPACK FOOTER //
// ./src/scripts/components/ReportDisplay/ReportTopForm/utils.js